import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        prjName: null, // 工程名称
        constructionNo: null, // 报建编号
        regulators: null, // 行政监督部门
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "项目编号：",
          value: "constructionNo",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请输入",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201512011001350003",
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "工程名称",
          prop: "prjName",
          isShow: true,
        },
        {
          label: "项目编号",
          prop: "constructionNo",
        },
        {
          label: "工程类别",
          prop: "prjLargeClassName",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
    }
  },

  // 接收父组件传递的数据
  props: {

  },

  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/construction/chooseList", {
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
    * 下拉框值改变事件
    * @author shuhua
    */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 项目选择
     * @author shuhua
     */
    fun_ProjectSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 报建信息表主键
        this.$parent.form.constructionId = e.val.id;
        // 赋值父页面报建编号
        this.$parent.form.constructionNo = e.val.constructionNo;
        // 赋值父页面项目名称
        this.$parent.form.prjName = e.val.prjName;
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
}